import { render, staticRenderFns } from "./DemoProjectDialog.vue?vue&type=template&id=4fdbb038&scoped=true"
import script from "./DemoProjectDialog.vue?vue&type=script&lang=js"
export * from "./DemoProjectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdbb038",
  null
  
)

export default component.exports